import { Add01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { ButtonBase, CardMedia, IconButton, useTheme } from "@mui/material";
import ScheduleAvailability from "@/components/ScheduleAvailability";
import { Schedule } from "@/types/branch";
import "./ColumnFree.scss";

interface ColumnFreeProps {
  title: string;
  description: string;
  price: string | React.ReactNode;
  image?: string;
  isDisabled?: boolean;
  onClick?: () => void;
  schedule?: Schedule;
}

const ColumnFree = ({ title, description, price, image, isDisabled, onClick, schedule }: Partial<ColumnFreeProps>) => {
  const theme = useTheme();

  return (
    <ButtonBase
      className="dish dish--column-free"
      onClick={onClick}
      component="div"
      sx={{
        opacity: isDisabled ? 0.5 : 1,
        ["& .dish__title"]: {
          textDecoration: isDisabled ? "line-through" : "none",
        },
      }}
    >
      <CardMedia className="dish__image" component={"img"} title={title} image={image} />

      <div className="dish__body">
        <h3 className="dish__title">{title}</h3>
        {schedule ? (
          <div className="dish__schedule">
            <ScheduleAvailability availability={schedule} />
          </div>
        ) : null}
        <p className="dish__description">{description}</p>
        <p className="dish__price">{price}</p>

        <div className="dish__actions">
          <IconButton className="dish__btn-details" onClick={onClick} sx={{ backgroundColor: theme.palette.primary.main }}>
            <HugeiconsIcon icon={Add01Icon} className="dish__btn-icon" color="white" />
          </IconButton>
        </div>
      </div>
    </ButtonBase>
  );
};

export default ColumnFree;
